export const constants = {
  apiUrl: '/hybris/selfcare/b2c/v1/',
  mvcRoute: '/selfcare/b2c/',
  origamiRoute: '/',
  refreshToken: 'auth/refreshToken'
}
